<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs4-02",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 54,
      nextPage: '/questionnaire/section4/3',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'normalBtn'
        },
        mainTitle: 'Do you often have oral ulcers?',
        btn: [
          [
            {
              text: 'Yes',
              operation: 'add suggestion 12'
            },{
              text: 'No',
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
